module.exports = __webpack_public_path__ + "img/redeem-coins-image.png";